import * as timeago from 'timeago.js';
import de from 'timeago.js/lib/lang/de';
import es from 'timeago.js/lib/lang/pl';
import fr from 'timeago.js/lib/lang/fr';
import pl from 'timeago.js/lib/lang/pl';
import pt from 'timeago.js/lib/lang/pt_BR';
import { register, render } from 'timeago.js';

window.Timeago = {};

Timeago.init = function() {
  timeago.register('de', de);
  timeago.register('es', es);
  timeago.register('fr', fr);
  timeago.register('pl', pl);
  timeago.register('pt', pt);

  Timeago.formatDate();
};

Timeago.formatDate = function() {
  $('.timeago').each((i, elem) => {
    elem.innerHTML = timeago.format(elem.getAttribute('datetime'), I18n.locale)
  })
}
